import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import checkDouble from "Assets/Icons/check-double.svg";

const AddAccountSuccess = ({
  successTitle = "Bank Account Added",
  successMsg = "You've successfully added an account.",
  removeAccount,
}) => {
  return (
    <Row className="success">
      <Col sm={4}>
        <span className="helper"></span>
        <img src={checkDouble} alt="Checkmark" className="icon" />
      </Col>
      <Col sm={8} className="message">
        <h3>{successTitle}</h3>
        <p>{successMsg}</p>
        {removeAccount && (
          <button className="link" onClick={removeAccount}>
            Remove Account
          </button>
        )}
      </Col>
    </Row>
  );
};

export default AddAccountSuccess;
